import AllGames from "./AllGames";

export default AllGames;